import React from "react";
import Text from "../../components/typography";
import MovingHeadline from "../../components/moving-headline";
import "../experience/styles.css";

const Experience = () => {
  return (
    <>
      <div className="green-background-left">
        <div className="green-place-text-left">
          <Text
            variant="montserrat-bold-text"
            fontSize={36}
            color="darkGreenText"
          >
            PUNE
          </Text>
        </div>
        <div className="green-content">
          <Text variant="montserrat-semibold" fontSize={36} color="darkBlue">
            Bajaj Finserv Health Limited
          </Text>
          <Text variant="montserrat-semibold" fontSize={22} color="darkBlue">
            Software Development Engineer
          </Text>
          <div className="skills-container-column">
            <div className="skills-container">
              <Text
                variant="montserrat-semibold"
                fontSize={18}
                color="whiteText"
              >
                HTML
              </Text>
              <div className="small-ellipse"></div>
              <Text
                variant="montserrat-semibold"
                fontSize={18}
                color="whiteText"
              >
                CSS
              </Text>
              <div className="small-ellipse"></div>
              <Text
                variant="montserrat-semibold"
                fontSize={18}
                color="whiteText"
              >
                React Native
              </Text>
              <div className="small-ellipse"></div>
              <Text
                variant="montserrat-semibold"
                fontSize={18}
                color="whiteText"
              >
                ReactJS
              </Text>
            </div>
            <div className="skills-container">
              <Text
                variant="montserrat-semibold"
                fontSize={18}
                color="whiteText"
              >
                Typescript
              </Text>
              <div className="small-ellipse"></div>
              <Text
                variant="montserrat-semibold"
                fontSize={18}
                color="whiteText"
              >
                Javascript
              </Text>
              <div className="small-ellipse"></div>
              <Text
                variant="montserrat-semibold"
                fontSize={18}
                color="whiteText"
              >
                NextJS
              </Text>
              <div className="small-ellipse"></div>
              <Text
                variant="montserrat-semibold"
                fontSize={18}
                color="whiteText"
              >
                CI/CD
              </Text>
            </div>
          </div>
          <Text variant="montserrat-semibold" fontSize={20} color="darkBlue">
            July 2023 - April 2025
          </Text>
        </div>
      </div>

      <div className="blue-background-right">
        <div className="blue-place-text-right">
          <Text
            variant="montserrat-bold-text"
            fontSize={36}
            color="darkBlueText"
          >
            PUNE
          </Text>
        </div>
        <div className="blue-content">
          <Text variant="montserrat-semibold" fontSize={36} color="yellow">
            Bajaj Finserv Health Limited
          </Text>
          <Text variant="montserrat-semibold" fontSize={22} color="yellow">
            Software Developer Intern
          </Text>
          <div className="skills-container-column">
            <div className="skills-container">
              <Text
                variant="montserrat-semibold"
                fontSize={18}
                color="whiteText"
              >
                React Native
              </Text>
              <div className="small-ellipse"></div>
              <Text
                variant="montserrat-semibold"
                fontSize={18}
                color="whiteText"
              >
                Javascript
              </Text>
              <div className="small-ellipse"></div>
              <Text
                variant="montserrat-semibold"
                fontSize={18}
                color="whiteText"
              >
                ElasticSearch
              </Text>
            </div>
            <div className="skills-container">
              <Text
                variant="montserrat-semibold"
                fontSize={18}
                color="whiteText"
              >
                SonarQube
              </Text>
              <div className="small-ellipse"></div>
              <Text
                variant="montserrat-semibold"
                fontSize={18}
                color="whiteText"
              >
                Typescript
              </Text>
            </div>
          </div>
          <Text variant="montserrat-semibold" fontSize={20} color="yellow">
            Jan 2023 - July 2023
          </Text>
        </div>
      </div>

      <div className="green-background-right">
        <div className="green-place-text-right">
          <Text
            variant="montserrat-bold-text"
            fontSize={36}
            color="darkGreenText"
          >
            DUBAI
          </Text>
        </div>
        <div className="green-content">
          <Text variant="montserrat-semibold" fontSize={36} color="darkBlue">
            REDA Chemicals
          </Text>
          <Text variant="montserrat-semibold" fontSize={22} color="darkBlue">
            Web Developer & Graphic Design Intern
          </Text>
          <div className="skills-container-column">
            <div className="skills-container">
              <Text
                variant="montserrat-semibold"
                fontSize={18}
                color="whiteText"
              >
                HTML
              </Text>
              <div className="small-ellipse"></div>
              <Text
                variant="montserrat-semibold"
                fontSize={18}
                color="whiteText"
              >
                CSS
              </Text>
              <div className="small-ellipse"></div>
              <Text
                variant="montserrat-semibold"
                fontSize={18}
                color="whiteText"
              >
                UI/UX
              </Text>
              <div className="small-ellipse"></div>
              <Text
                variant="montserrat-semibold"
                fontSize={18}
                color="whiteText"
              >
                WordPress
              </Text>
            </div>
            <div className="skills-container">
              <Text
                variant="montserrat-semibold"
                fontSize={18}
                color="whiteText"
              >
                Adobe Photoshop
              </Text>
              <div className="small-ellipse"></div>
              <Text
                variant="montserrat-semibold"
                fontSize={18}
                color="whiteText"
              >
                Adobe Illustrator
              </Text>
            </div>
          </div>
          <Text variant="montserrat-semibold" fontSize={20} color="darkBlue">
            Aug 2021 - Oct 2021
          </Text>
        </div>
      </div>

      <div className="blue-background-left">
        <div className="blue-place-text-left">
          <Text
            variant="montserrat-bold-text"
            fontSize={36}
            color="darkBlueText"
          >
            PUNE
          </Text>
        </div>
        <div className="blue-content">
          <Text variant="montserrat-semibold" fontSize={36} color="yellow">
            Avon Building Solutions Pvt Ltd.
          </Text>
          <Text variant="montserrat-semibold" fontSize={22} color="yellow">
            Engineering Intern
          </Text>
          <div className="skills-container-column">
            <div className="skills-container">
              <Text
                variant="montserrat-semibold"
                fontSize={18}
                color="whiteText"
              >
                ERPNext
              </Text>
              <div className="small-ellipse"></div>
              <Text
                variant="montserrat-semibold"
                fontSize={18}
                color="whiteText"
              >
                DigitalOcean
              </Text>
              <div className="small-ellipse"></div>
              <Text
                variant="montserrat-semibold"
                fontSize={18}
                color="whiteText"
              >
                Javascript
              </Text>
            </div>
          </div>
          <Text variant="montserrat-semibold" fontSize={20} color="yellow">
            Feb 2022 - May 2022
          </Text>
        </div>
      </div>

      <MovingHeadline displayText="EXPERIENCE" isMiddle={true} fontSize={138} />
    </>
  );
};

export default Experience;
